var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 80,
    viewBox: "0 0 203 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 4,
    width: 27,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.94 4.73047H77.7618V41.4716H103.94V4.73047Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 4,
    width: 26,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2181 13.3646C100.85 21.8151 106.737 36.9249 102.145 40.2775C97.5521 43.6301 85.8617 33.1589 81.3526 25.7188C76.8852 18.2788 76.9687 9.55272 81.5614 6.20009C86.154 2.84746 93.9615 5.74083 97.2181 13.3646Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8416 2.89338L76.8853 44.5487L107.74 43.6301L106.696 1.97485L75.8416 2.89338Z",
    fill: "url(#paint0_linear_8_5)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 0,
    width: 22,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.62 0H89.4521V41.4716H110.62V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8_5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 0,
    width: 22,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.411 16.3039C110.203 26.2699 105.735 40.8746 100.224 41.0123C94.713 41.1501 89.9533 25.3973 89.7863 16.4417C89.6193 7.48603 93.9614 0.183727 99.4726 0.0918745C105.026 2.16514e-05 110.62 6.70528 110.411 16.3039Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_8_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.6169 2.31266e-05L89.6607 41.7472L111.622 41.1042L110.578 -0.642944L88.6169 2.31266e-05Z",
    fill: "url(#paint1_linear_8_5)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 5,
    width: 28,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.981 5.32751H96.1326V41.4716H123.981V5.32751Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_8_5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_8_5",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 5,
    width: 28,
    height: 37
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.555 26.4077C113.96 32.8833 102.979 43.9057 98.4703 40.4153C93.9612 36.9249 98.5539 21.1262 103.188 13.8238C107.823 6.52154 115.254 3.39854 119.805 6.88895C124.314 10.3334 125.984 18.9217 119.555 26.4077Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_8_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9176 3.44446L93.9613 44.8701L127.028 43.8597L125.985 2.43408L92.9176 3.44446Z",
    fill: "url(#paint2_linear_8_5)"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88693 67.0028C4.75965 67.0028 3.71587 66.7732 2.88084 66.3599C2.00406 65.9465 1.29429 65.3036 0.793276 64.5228C0.29226 63.6961 0.0417513 62.7317 0 61.5835H3.00609C3.04785 62.3643 3.29835 63.0532 3.79937 63.6043C4.30038 64.1554 4.96841 64.431 5.84518 64.431C6.59671 64.431 7.22298 64.2473 7.64049 63.8339C8.09976 63.4206 8.30851 62.9154 8.30851 62.2265C8.30851 61.5376 8.09975 60.9865 7.72399 60.5731C7.34823 60.1598 6.80546 59.8383 6.13744 59.6087C5.46942 59.3791 4.8014 59.1035 4.04988 58.8279C2.83909 58.3687 1.92056 57.7716 1.29429 57.0827C0.66802 56.3479 0.375762 55.3835 0.375762 54.2353C0.375762 53.2249 0.584518 52.3523 1.04378 51.6175C1.50305 50.8827 2.12932 50.3315 2.92259 49.9182C3.71587 49.5049 4.6344 49.3212 5.63643 49.3212C6.68021 49.3212 7.59874 49.5049 8.39201 49.9182C9.18529 50.3315 9.81156 50.8827 10.2708 51.6634C10.7301 52.3982 10.9806 53.2708 11.0223 54.2812H7.9745C7.9745 53.6842 7.72399 53.1331 7.34823 52.6738C6.93072 52.2145 6.38795 51.9849 5.63643 51.9849C5.01016 51.9849 4.50914 52.1227 4.04988 52.4901C3.63236 52.8575 3.42361 53.3627 3.42361 54.0057C3.42361 54.5568 3.59061 55.016 3.92462 55.3835C4.25863 55.7049 4.67615 55.9805 5.26066 56.2101C5.84518 56.4398 6.47145 56.6694 7.18122 56.945C7.93275 57.2664 8.64252 57.5879 9.31054 57.9553C9.93681 58.3227 10.4796 58.8739 10.8553 59.5168C11.2311 60.1598 11.4399 60.9865 11.4399 61.9969C11.4399 62.9154 11.2311 63.7421 10.8136 64.5228C10.3961 65.3036 9.76981 65.9006 8.97653 66.3599C8.058 66.7732 7.05597 67.0028 5.88693 67.0028Z",
    fill: "#0D2329"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8164 67.0028C15.4386 67.0028 14.3531 66.5436 13.6016 65.5791C12.85 64.6147 12.4743 63.2369 12.4743 61.3998V54.5568H15.3134V61.1242C15.3134 62.1806 15.5221 62.9613 15.8979 63.5124C16.2737 64.0635 16.8999 64.3391 17.735 64.3391C18.5282 64.3391 19.1545 64.0176 19.6555 63.4206C20.1565 62.8235 20.4488 61.9509 20.4488 60.8487V54.5568H23.2879V66.7273H20.7828L20.574 64.6606C20.24 65.3954 19.739 65.9465 19.071 66.4058C18.403 66.7732 17.6515 67.0028 16.8164 67.0028Z",
    fill: "#0D2329"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0905 72.1006V54.5567H27.6373L27.9713 56.3019C28.3471 55.7508 28.8063 55.2915 29.3909 54.8782C29.9754 54.4648 30.7269 54.2811 31.6872 54.2811C32.731 54.2811 33.6495 54.5567 34.4845 55.1078C35.3196 55.6589 35.9458 56.4397 36.4051 57.4041C36.8644 58.3686 37.1149 59.4708 37.1149 60.6649C37.1149 61.9049 36.8644 62.9612 36.4051 63.9257C35.9458 64.8901 35.2778 65.625 34.4845 66.1761C33.6495 66.7272 32.731 67.0028 31.6872 67.0028C30.8522 67.0028 30.1424 66.819 29.5161 66.4976C28.8899 66.1302 28.3888 65.6709 28.0131 65.0738V72.1465H25.0905V72.1006ZM31.0192 64.2472C31.9377 64.2472 32.6892 63.9257 33.2737 63.2368C33.8583 62.5479 34.1505 61.7212 34.1505 60.6649C34.1505 59.6086 33.8583 58.736 33.2737 58.0471C32.6892 57.3582 31.9377 57.0367 31.0192 57.0367C30.1006 57.0367 29.3491 57.3582 28.7646 58.0471C28.1801 58.736 27.8878 59.6086 27.8878 60.6649C27.8878 61.7212 28.1801 62.5938 28.7646 63.2827C29.3491 63.9257 30.1006 64.2472 31.0192 64.2472Z",
    fill: "#0D2329"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4835 66.6813V54.5567H41.0303L41.2808 56.853C41.6983 56.0723 42.2411 55.4293 42.9091 54.97C43.6189 54.5108 44.4122 54.2811 45.3307 54.2811V57.5878H44.5792C43.9529 57.5878 43.4101 57.6797 42.9091 57.9093C42.4081 58.1389 42.0323 58.5064 41.7401 59.0116C41.4478 59.5167 41.3226 60.2516 41.3226 61.1701V66.7272H38.4835V66.6813Z",
    fill: "#0D2329"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5677 67.0028C50.4404 67.0028 49.4801 66.7272 48.6033 66.222C47.7265 65.7168 47.0585 64.982 46.5575 64.0176C46.0565 63.0531 45.806 61.9509 45.806 60.7109C45.806 59.4708 46.0565 58.3227 46.5157 57.3582C47.0168 56.3938 47.6848 55.613 48.5198 55.0619C49.3548 54.5108 50.3569 54.2352 51.5259 54.2352C52.6114 54.2352 53.5717 54.5108 54.4067 55.016C55.2418 55.5212 55.9098 56.256 56.3691 57.1745C56.8283 58.0931 57.0788 59.1034 57.0788 60.2057C57.0788 60.3894 57.0788 60.5731 57.0788 60.7568C57.0788 60.9405 57.0788 61.1701 57.0371 61.3538H48.6451C48.6868 62.3183 49.0208 63.0531 49.5218 63.6042C50.0646 64.1553 50.7326 64.4309 51.4841 64.4309C52.0687 64.4309 52.5279 64.2931 52.9454 64.0176C53.3212 63.742 53.6552 63.3746 53.8222 62.9153H56.7031C56.4943 63.6961 56.1603 64.385 55.6593 65.0279C55.1583 65.6709 54.5737 66.1302 53.864 66.4976C53.2377 66.8191 52.4444 67.0028 51.5677 67.0028ZM51.5677 56.8071C50.8579 56.8071 50.2734 57.0367 49.7306 57.4501C49.1878 57.8634 48.8538 58.5523 48.7286 59.4249H54.2397C54.198 58.5982 53.9057 58.0012 53.4465 57.496C52.9037 57.0367 52.3192 56.8071 51.5677 56.8071Z",
    fill: "#0D2329"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3801 66.6813V54.5567H60.8852L61.1357 56.2101C61.4697 55.613 61.9708 55.1538 62.5553 54.7863C63.1398 54.4189 63.8078 54.2812 64.6011 54.2812C66.3129 54.2812 67.5237 55.016 68.2335 56.4397C68.651 55.7508 69.152 55.2456 69.8618 54.8323C70.5298 54.4649 71.2813 54.2352 72.0746 54.2352C73.5359 54.2352 74.6214 54.6945 75.4147 55.6589C76.1662 56.6234 76.5837 58.0012 76.5837 59.8383V66.6813H73.7029V60.1138C73.7029 59.0575 73.5359 58.2768 73.1601 57.7256C72.7843 57.1745 72.2416 56.899 71.4901 56.899C70.7385 56.899 70.1123 57.2204 69.6112 57.8175C69.152 58.4145 68.9015 59.2871 68.9015 60.3894V66.6354H66.0624V60.0679C66.0624 59.0116 65.8954 58.2308 65.5196 57.6797C65.1439 57.1286 64.5593 56.853 63.8078 56.853C63.0563 56.853 62.43 57.1745 61.9708 57.7716C61.5115 58.3686 61.261 59.2412 61.261 60.3434V66.5894H58.3801V66.6813Z",
    fill: "#0D2329"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5047 67.0028C82.3774 67.0028 81.4171 66.7272 80.5404 66.222C79.6636 65.7168 78.9956 64.982 78.4945 64.0176C77.9935 63.0531 77.743 61.9509 77.743 60.7109C77.743 59.4708 77.9935 58.3227 78.4528 57.3582C78.9538 56.3938 79.6218 55.613 80.4569 55.0619C81.2919 54.5108 82.2939 54.2352 83.463 54.2352C84.5485 54.2352 85.5088 54.5108 86.3438 55.016C87.1788 55.5212 87.8468 56.256 88.3061 57.1745C88.7654 58.0931 89.0159 59.1034 89.0159 60.2057C89.0159 60.3894 89.0159 60.5731 89.0159 60.7568C89.0159 60.9405 89.0159 61.1701 88.9741 61.3538H80.5821C80.6239 62.3183 80.9579 63.0531 81.4589 63.6042C82.0017 64.1553 82.6697 64.4309 83.4212 64.4309C84.0057 64.4309 84.465 64.2931 84.8825 64.0176C85.2583 63.742 85.5923 63.3746 85.7593 62.9153H88.6401C88.4314 63.6961 88.0973 64.385 87.5963 65.0279C87.0953 65.6709 86.5108 66.1302 85.801 66.4976C85.1748 66.8191 84.3815 67.0028 83.5047 67.0028ZM83.5465 56.8071C82.8367 56.8071 82.2522 57.0367 81.7094 57.4501C81.1666 57.8634 80.8326 58.5523 80.7074 59.4249H86.2185C86.1768 58.5982 85.8845 58.0012 85.4253 57.496C84.8407 57.0367 84.2562 56.8071 83.5465 56.8071Z",
    fill: "#0D2329"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5841 66.6813V49.5508H97.4232L104.73 61.6294V49.5508H107.569V66.6813H104.73L97.465 54.6486V66.6813H94.5841Z",
    fill: "#0D2329"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.596 67.0028C112.219 67.0028 111.133 66.5436 110.382 65.5791C109.63 64.6147 109.254 63.2369 109.254 61.3998V54.5568H112.093V61.1242C112.093 62.1806 112.302 62.9613 112.678 63.5124C113.054 64.0635 113.68 64.3391 114.515 64.3391C115.308 64.3391 115.935 64.0176 116.436 63.4206C116.937 62.8235 117.229 61.9509 117.229 60.8487V54.5568H120.068V66.7273H117.563L117.354 64.6606C117.02 65.3954 116.519 65.9465 115.851 66.4058C115.225 66.7732 114.473 67.0028 113.596 67.0028Z",
    fill: "#0D2329"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.797 66.6813C125.628 66.6813 124.71 66.3598 124 65.7627C123.29 65.1198 122.956 64.0175 122.956 62.456V57.1745H121.077V54.5567H122.956L123.29 51.2959H125.795V54.5567H128.759V57.1745H125.795V62.502C125.795 63.099 125.92 63.5123 126.129 63.696C126.38 63.9257 126.755 64.0175 127.34 64.0175H128.718V66.6813H126.797Z",
    fill: "#0D2329"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.153 66.6813V54.5567H132.7L132.951 56.853C133.368 56.0723 133.911 55.4293 134.579 54.97C135.289 54.5108 136.082 54.2811 137 54.2811V57.5878H136.207C135.581 57.5878 135.038 57.6797 134.537 57.9093C134.036 58.1389 133.66 58.5064 133.368 59.0116C133.076 59.5167 132.951 60.2516 132.951 61.1701V66.7272H130.153V66.6813Z",
    fill: "#0D2329"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.651 67.0028C140.69 67.0028 139.939 66.8191 139.313 66.4976C138.686 66.1761 138.269 65.7168 137.977 65.1657C137.684 64.6146 137.517 64.0175 137.517 63.3286C137.517 62.1805 137.935 61.3079 138.728 60.5731C139.521 59.8842 140.732 59.5167 142.319 59.5167H145.116V59.2412C145.116 58.4145 144.907 57.8175 144.448 57.4041C144.03 56.9908 143.488 56.8071 142.861 56.8071C142.277 56.8071 141.776 56.9449 141.358 57.2663C140.941 57.5878 140.649 58.0012 140.565 58.5982H137.768C137.851 57.7256 138.102 56.9449 138.561 56.3019C139.02 55.6589 139.647 55.1537 140.398 54.7863C141.15 54.4189 141.985 54.2811 142.903 54.2811C144.49 54.2811 145.701 54.6945 146.619 55.5671C147.538 56.4397 147.955 57.6338 147.955 59.2412V66.7272H145.534L145.283 64.7524C144.949 65.3953 144.49 65.9464 143.905 66.3598C143.321 66.7731 142.569 67.0028 141.651 67.0028ZM142.319 64.5227C143.154 64.5227 143.78 64.2472 144.239 63.6501C144.699 63.0531 144.991 62.3183 145.116 61.4457H142.694C141.943 61.4457 141.4 61.5834 141.066 61.9049C140.732 62.2264 140.565 62.5938 140.565 63.0072C140.565 63.4664 140.732 63.8338 141.066 64.1094C141.358 64.4309 141.776 64.5227 142.319 64.5227Z",
    fill: "#0D2329"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.143 67.0028C158.016 67.0028 156.972 66.7732 156.137 66.3599C155.261 65.9465 154.551 65.3036 154.05 64.5228C153.549 63.6961 153.298 62.7317 153.257 61.5835H156.263C156.304 62.3643 156.555 63.0532 157.056 63.6043C157.557 64.1554 158.225 64.431 159.102 64.431C159.853 64.431 160.479 64.2473 160.897 63.8339C161.356 63.4206 161.565 62.9154 161.565 62.2265C161.565 61.5376 161.356 60.9865 160.981 60.5731C160.605 60.1598 160.062 59.8383 159.394 59.6087C158.726 59.3791 158.058 59.1035 157.306 58.8279C156.096 58.3687 155.177 57.7716 154.551 57.0827C153.925 56.3479 153.632 55.3835 153.632 54.2353C153.632 53.2249 153.841 52.3523 154.3 51.6175C154.76 50.8827 155.386 50.3315 156.179 49.9182C156.972 49.5049 157.891 49.3212 158.893 49.3212C159.937 49.3212 160.855 49.5049 161.649 49.9182C162.442 50.3315 163.068 50.8827 163.527 51.6634C163.987 52.3982 164.237 53.2708 164.279 54.2812H161.231C161.231 53.6842 160.981 53.1331 160.605 52.6738C160.187 52.2145 159.644 51.9849 158.893 51.9849C158.267 51.9849 157.766 52.1227 157.306 52.4901C156.889 52.8575 156.68 53.3627 156.68 54.0057C156.68 54.5568 156.847 55.016 157.181 55.3835C157.515 55.7049 157.933 55.9805 158.517 56.2101C159.102 56.4398 159.728 56.6694 160.438 56.945C161.189 57.2664 161.899 57.5879 162.567 57.9553C163.193 58.3227 163.736 58.8739 164.112 59.5168C164.488 60.1598 164.696 60.9865 164.696 61.9969C164.696 62.9154 164.488 63.7421 164.07 64.5228C163.653 65.3036 163.026 65.9006 162.233 66.3599C161.356 66.7732 160.354 67.0028 159.143 67.0028Z",
    fill: "#0D2329"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.94 66.6813V49.0455H168.779V56.3938C169.155 55.7049 169.656 55.1997 170.282 54.8323C170.908 54.4649 171.618 54.2811 172.453 54.2811C173.831 54.2811 174.874 54.7404 175.626 55.7049C176.378 56.6693 176.753 58.0471 176.753 59.8842V66.7272H173.914V60.1597C173.914 59.1034 173.705 58.3227 173.33 57.7716C172.954 57.2204 172.369 56.9449 171.534 56.9449C170.741 56.9449 170.073 57.2664 169.53 57.8634C168.988 58.4605 168.737 59.3331 168.737 60.4353V66.6813H165.94Z",
    fill: "#0D2329"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M183.691 67.0028C182.606 67.0028 181.646 66.7272 180.811 66.1761C179.976 65.625 179.266 64.8902 178.765 63.9257C178.264 62.9613 178.013 61.859 178.013 60.619C178.013 59.379 178.264 58.2768 178.765 57.3123C179.266 56.3478 179.976 55.613 180.811 55.0619C181.646 54.5108 182.606 54.2352 183.691 54.2352C184.735 54.2352 185.695 54.5108 186.572 55.0619C187.407 55.613 188.117 56.3478 188.618 57.3123C189.119 58.2768 189.37 59.379 189.37 60.619C189.37 61.859 189.119 62.9613 188.618 63.9257C188.117 64.8902 187.449 65.625 186.572 66.1761C185.695 66.7272 184.735 67.0028 183.691 67.0028ZM183.691 64.2931C184.443 64.2931 185.069 63.9716 185.612 63.3746C186.155 62.7775 186.447 61.859 186.447 60.619C186.447 59.4249 186.155 58.5064 185.612 57.9093C185.069 57.3123 184.443 56.9908 183.691 56.9908C182.94 56.9908 182.272 57.3123 181.729 57.9093C181.186 58.5064 180.936 59.4249 180.936 60.619C180.936 61.8131 181.186 62.7316 181.729 63.3746C182.272 63.9716 182.94 64.2931 183.691 64.2931Z",
    fill: "#0D2329"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.763 72.1007V54.5568H193.31L193.644 56.302C194.019 55.7509 194.479 55.2916 195.063 54.8783C195.648 54.465 196.399 54.2812 197.359 54.2812C198.403 54.2812 199.322 54.5568 200.157 55.1079C200.992 55.659 201.618 56.4398 202.077 57.4042C202.537 58.3687 202.787 59.4709 202.787 60.665C202.787 61.905 202.537 62.9613 202.077 63.9258C201.618 64.8903 200.95 65.6251 200.157 66.1762C199.322 66.7273 198.403 67.0029 197.359 67.0029C196.524 67.0029 195.815 66.8192 195.188 66.4977C194.562 66.1303 194.061 65.671 193.685 65.074V72.1466H190.763V72.1007ZM196.691 64.2473C197.61 64.2473 198.361 63.9258 198.946 63.2369C199.53 62.548 199.823 61.7213 199.823 60.665C199.823 59.6087 199.53 58.7361 198.946 58.0472C198.361 57.3583 197.61 57.0368 196.691 57.0368C195.773 57.0368 195.021 57.3583 194.437 58.0472C193.852 58.7361 193.56 59.6087 193.56 60.665C193.56 61.7213 193.852 62.5939 194.437 63.2828C195.021 63.9258 195.773 64.2473 196.691 64.2473Z",
    fill: "#0D2329"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2326 80V74.4429H61.1512V79.2192H63.4057V80H60.2326Z",
    fill: "#7ED957"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2664 80V74.4429H69.1849V80H68.2664Z",
    fill: "#7ED957"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7028 80L73.8657 74.4429H74.8677L76.2873 78.9896L77.7486 74.4429H78.7089L76.8718 80H75.7028Z",
    fill: "#7ED957"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.37 80V74.4429H86.6683V75.2695H84.2885V76.7851H86.4596V77.5659H84.2885V79.1733H86.6683V80H83.37Z",
    fill: "#7ED957"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3838 80V74.4429H99.4296C99.9724 74.4429 100.348 74.5807 100.64 74.8562C100.933 75.1318 101.058 75.4533 101.058 75.8666C101.058 76.234 100.974 76.5096 100.807 76.6933C100.64 76.9229 100.432 77.0607 100.181 77.1066C100.473 77.1525 100.724 77.3362 100.891 77.5659C101.1 77.7955 101.183 78.117 101.183 78.4385C101.183 78.8977 101.058 79.2651 100.766 79.5407C100.473 79.8163 100.056 79.954 99.5549 79.954H97.3838V80ZM98.3023 76.7392H99.2626C99.5131 76.7392 99.7219 76.6933 99.8471 76.5555C99.9724 76.4177 100.056 76.234 100.056 76.0044C100.056 75.7747 99.9724 75.591 99.8471 75.4533C99.7219 75.3155 99.5131 75.2236 99.2208 75.2236H98.2606V76.7392H98.3023ZM98.3023 79.1733H99.3461C99.6384 79.1733 99.8471 79.0814 99.9724 78.9437C100.139 78.8059 100.223 78.6222 100.223 78.3466C100.223 78.0711 100.139 77.8874 99.9724 77.7496C99.8054 77.6118 99.5966 77.5199 99.3461 77.5199H98.3441V79.1733H98.3023Z",
    fill: "#7ED957"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.976 80V74.4429H109.274V75.2695H106.895V76.7851H109.066V77.5659H106.895V79.1733H109.274V80H105.976Z",
    fill: "#7ED957"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M115.409 80V75.2236H113.947V74.397H117.83V75.2236H116.369V80H115.409Z",
    fill: "#7ED957"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M123.701 80V75.2236H122.24V74.397H126.123V75.2236H124.661V80H123.701Z",
    fill: "#7ED957"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M130.866 80V74.4429H134.164V75.2695H131.784V76.7851H133.955V77.5659H131.784V79.1733H134.164V80H130.866Z",
    fill: "#7ED957"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.087 80V74.4429H140.924C141.342 74.4429 141.676 74.5347 141.926 74.6725C142.177 74.8103 142.385 75.0399 142.511 75.2695C142.636 75.5451 142.719 75.8207 142.719 76.1421C142.719 76.4636 142.636 76.7851 142.469 77.0607C142.302 77.3362 142.051 77.5659 141.717 77.6577L142.761 80H141.676L140.757 77.7955H140.005V80H139.087ZM140.047 77.0148H140.924C141.216 77.0148 141.467 76.9229 141.592 76.7851C141.717 76.6014 141.801 76.4177 141.801 76.1421C141.801 75.8666 141.717 75.6829 141.592 75.4992C141.467 75.3614 141.216 75.2695 140.924 75.2695H140.047V77.0148Z",
    fill: "#7ED957"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_5",
    x1: 78.3643,
    y1: 0.96235,
    x2: 108.798,
    y2: 42.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14EDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#14EDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#14EDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#14ECB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1016,
    stopColor: "#14EBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1055,
    stopColor: "#14EBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1094,
    stopColor: "#14EAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1133,
    stopColor: "#13E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1172,
    stopColor: "#13E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#13E8B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#13E7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    stopColor: "#13E7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#13E6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#13E5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1406,
    stopColor: "#13E4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    stopColor: "#13E4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1484,
    stopColor: "#13E3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1523,
    stopColor: "#13E2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    stopColor: "#13E2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#13E1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    stopColor: "#13E0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#12E0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    stopColor: "#12DFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#12DEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#12DEAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1836,
    stopColor: "#12DDAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#12DCAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#12DBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1953,
    stopColor: "#12DBAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1992,
    stopColor: "#12DAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#12D9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#12D9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2109,
    stopColor: "#12D8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#12D7A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2188,
    stopColor: "#11D7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#11D6A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    stopColor: "#11D5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#11D5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#11D4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#11D3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    stopColor: "#11D2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#11D2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#11D1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    stopColor: "#11D0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#11D0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#11CFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#11CEA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2695,
    stopColor: "#10CEA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#10CDA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    stopColor: "#10CC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    stopColor: "#10CC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2852,
    stopColor: "#10CB9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2891,
    stopColor: "#10CA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#10C99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#10C99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3008,
    stopColor: "#10C89C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    stopColor: "#10C79B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#10C79B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#10C69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3164,
    stopColor: "#10C59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3203,
    stopColor: "#0FC599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    stopColor: "#0FC499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3281,
    stopColor: "#0FC398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#0FC298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3359,
    stopColor: "#0FC297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    stopColor: "#0FC197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    stopColor: "#0FC096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    stopColor: "#0FC095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3516,
    stopColor: "#0FBF95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3555,
    stopColor: "#0FBE94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#0FBE94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    stopColor: "#0FBD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3672,
    stopColor: "#0FBC93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    stopColor: "#0EBC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0EBB92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    stopColor: "#0EBA91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3828,
    stopColor: "#0EB991"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3867,
    stopColor: "#0EB990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    stopColor: "#0EB88F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3945,
    stopColor: "#0EB78F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#0EB78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4023,
    stopColor: "#0EB68E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4062,
    stopColor: "#0EB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4102,
    stopColor: "#0EB58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4141,
    stopColor: "#0EB48C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#0EB38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    stopColor: "#0DB38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4258,
    stopColor: "#0DB28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#0DB18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#0DB089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#0DB089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#0DAF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    stopColor: "#0DAE88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#0DAE87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    stopColor: "#0DAD87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#0DAC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#0DAC86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#0DAB85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4688,
    stopColor: "#0DAA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#0CA984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    stopColor: "#0CA983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#0CA883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#0CA782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#0CA782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#0CA681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4961,
    stopColor: "#0CA581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0CA580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5039,
    stopColor: "#0CA480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5078,
    stopColor: "#0CA37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5117,
    stopColor: "#0CA37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    stopColor: "#0CA27E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "#0CA17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#0CA07D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5273,
    stopColor: "#0BA07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5312,
    stopColor: "#0B9F7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5352,
    stopColor: "#0B9E7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#0B9E7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#0B9D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5469,
    stopColor: "#0B9C7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5508,
    stopColor: "#0B9C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5547,
    stopColor: "#0B9B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#0B9A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#0B9A77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#0B9977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    stopColor: "#0B9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5742,
    stopColor: "#0B9776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#0A9775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#0A9675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#0A9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#0A9574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    stopColor: "#0A9473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    stopColor: "#0A9373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#0A9372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6055,
    stopColor: "#0A9271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6094,
    stopColor: "#0A9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6133,
    stopColor: "#0A9070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6172,
    stopColor: "#0A9070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    stopColor: "#0A8F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#0A8E6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#098E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6328,
    stopColor: "#098D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#098C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#098C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6445,
    stopColor: "#098B6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    stopColor: "#098A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6523,
    stopColor: "#098A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    stopColor: "#09896A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6602,
    stopColor: "#09886A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6641,
    stopColor: "#098769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#098769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#098668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6758,
    stopColor: "#098568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6797,
    stopColor: "#088567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6836,
    stopColor: "#088467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#088366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#088365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6953,
    stopColor: "#088265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#088164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#088164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#088063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7109,
    stopColor: "#087F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    stopColor: "#087E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#087E62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7227,
    stopColor: "#087D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#087C61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#077C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#077B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7383,
    stopColor: "#077A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7422,
    stopColor: "#077A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    stopColor: "#07795E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#07785D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#07785D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7578,
    stopColor: "#07775C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7617,
    stopColor: "#07765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7656,
    stopColor: "#07755B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7695,
    stopColor: "#07755B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7734,
    stopColor: "#07745A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7773,
    stopColor: "#07735A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    stopColor: "#067359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#067258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7891,
    stopColor: "#067158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#067157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7969,
    stopColor: "#067057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8008,
    stopColor: "#066F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8047,
    stopColor: "#066E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#066E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#066D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8164,
    stopColor: "#066C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8203,
    stopColor: "#066C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8242,
    stopColor: "#066B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8281,
    stopColor: "#066A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#056A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#056951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8398,
    stopColor: "#056851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8438,
    stopColor: "#056850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8477,
    stopColor: "#056750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8516,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05664F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_5",
    x1: 100.921,
    y1: -1.1503,
    x2: 98.8387,
    y2: 42.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57FA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00390625,
    stopColor: "#57F978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#57F978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117187,
    stopColor: "#56F878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#56F778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195312,
    stopColor: "#55F778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#55F677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273437,
    stopColor: "#55F577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#54F477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351562,
    stopColor: "#54F477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#53F377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429687,
    stopColor: "#53F276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#53F276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#52F176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#52F076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#51EF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#51EF75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664062,
    stopColor: "#51EE75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#50ED75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#50ED75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#4FEC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820312,
    stopColor: "#4FEB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#4FEA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#4EEA74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#4EE974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#4DE874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1016,
    stopColor: "#4DE873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1055,
    stopColor: "#4DE773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1094,
    stopColor: "#4CE673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1133,
    stopColor: "#4CE573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1172,
    stopColor: "#4BE573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#4BE472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#4BE372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    stopColor: "#4AE272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#4AE272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#49E171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1406,
    stopColor: "#49E071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    stopColor: "#49E071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1484,
    stopColor: "#48DF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1523,
    stopColor: "#48DE71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    stopColor: "#47DD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#47DD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    stopColor: "#47DC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#46DB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    stopColor: "#46DB70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#45DA6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#45D96F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1836,
    stopColor: "#45D86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#44D86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#44D76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1953,
    stopColor: "#43D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1992,
    stopColor: "#43D66E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#43D56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#42D46E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2109,
    stopColor: "#42D36E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#41D36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2188,
    stopColor: "#41D26D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#41D16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    stopColor: "#40D16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#40D06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#3FCF6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#3FCE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    stopColor: "#3FCE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#3ECD6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3ECC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    stopColor: "#3DCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#3DCB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#3DCA6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#3CC96B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2695,
    stopColor: "#3CC96B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#3BC86A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    stopColor: "#3BC76A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    stopColor: "#3BC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2852,
    stopColor: "#3AC66A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2891,
    stopColor: "#3AC56A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#39C469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#39C469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3008,
    stopColor: "#39C369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    stopColor: "#38C269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#38C169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#37C168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3164,
    stopColor: "#37C068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3203,
    stopColor: "#37BF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    stopColor: "#36BF68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3281,
    stopColor: "#36BE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#35BD67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3359,
    stopColor: "#35BC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    stopColor: "#35BC67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    stopColor: "#34BB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    stopColor: "#34BA67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3516,
    stopColor: "#33BA66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3555,
    stopColor: "#33B966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#33B866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    stopColor: "#32B766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3672,
    stopColor: "#32B766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    stopColor: "#31B665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#31B565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    stopColor: "#31B465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3828,
    stopColor: "#30B465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3867,
    stopColor: "#30B365"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    stopColor: "#2FB264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3945,
    stopColor: "#2FB264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#2FB164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4023,
    stopColor: "#2EB064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4062,
    stopColor: "#2EAF64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4102,
    stopColor: "#2DAF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4141,
    stopColor: "#2DAE63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#2DAD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    stopColor: "#2CAD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4258,
    stopColor: "#2CAC63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#2BAB62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#2BAA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#2BAA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#2AA962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    stopColor: "#2AA862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#29A861"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    stopColor: "#29A761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#29A661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#28A561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#28A561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4688,
    stopColor: "#27A460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#27A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    stopColor: "#27A360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#26A260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#26A160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#25A05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#25A05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4961,
    stopColor: "#259F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#249E5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5039,
    stopColor: "#249D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5078,
    stopColor: "#239D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5117,
    stopColor: "#239C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    stopColor: "#239B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "#229B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#229A5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5273,
    stopColor: "#21995D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5312,
    stopColor: "#21985D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5352,
    stopColor: "#21985D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#20975D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#20965D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5469,
    stopColor: "#20965C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5508,
    stopColor: "#1F955C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5547,
    stopColor: "#1F945C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#1E935C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#1E935C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#1E925B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    stopColor: "#1D915B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5742,
    stopColor: "#1D915B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#1C905B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#1C8F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#1C8E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#1B8E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    stopColor: "#1B8D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    stopColor: "#1A8C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#1A8C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6055,
    stopColor: "#1A8B59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6094,
    stopColor: "#198A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6133,
    stopColor: "#198959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6172,
    stopColor: "#188959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    stopColor: "#188859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#188758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#178658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6328,
    stopColor: "#178658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#168558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#168458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6445,
    stopColor: "#168457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    stopColor: "#158357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6523,
    stopColor: "#158257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    stopColor: "#148157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6602,
    stopColor: "#148157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6641,
    stopColor: "#148056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#137F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#137F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6758,
    stopColor: "#127E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6797,
    stopColor: "#127D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6836,
    stopColor: "#127C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#117C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#117B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6953,
    stopColor: "#107A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#107A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#107954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#0F7854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7109,
    stopColor: "#0F7754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    stopColor: "#0E7754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#0E7654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7227,
    stopColor: "#0E7553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#0D7553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#0D7453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#0C7353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7383,
    stopColor: "#0C7253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7422,
    stopColor: "#0C7252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    stopColor: "#0B7152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0B7052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#0A6F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7578,
    stopColor: "#0A6F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7617,
    stopColor: "#0A6E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7656,
    stopColor: "#096D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7695,
    stopColor: "#096D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7734,
    stopColor: "#086C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7773,
    stopColor: "#086B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    stopColor: "#086A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#076A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7891,
    stopColor: "#076950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#066850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7969,
    stopColor: "#06684F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8008,
    stopColor: "#06674F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8047,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9604,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05664F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_5",
    x1: 126.034,
    y1: 2.48866,
    x2: 90.1323,
    y2: 41.2922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1FF5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D1FF5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#D1FF5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1094,
    stopColor: "#D1FF5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1133,
    stopColor: "#D0FE5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1172,
    stopColor: "#CFFD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1211,
    stopColor: "#CDFC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#CCFB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    stopColor: "#CBFB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#CAFA5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1367,
    stopColor: "#C9F95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1406,
    stopColor: "#C8F85C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    stopColor: "#C7F75C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1484,
    stopColor: "#C6F65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1523,
    stopColor: "#C4F65C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1562,
    stopColor: "#C3F55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1602,
    stopColor: "#C2F45C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    stopColor: "#C1F35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#C0F25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1719,
    stopColor: "#BFF15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#BEF05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDF05C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1836,
    stopColor: "#BBEF5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#BAEE5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#B9ED5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1953,
    stopColor: "#B8EC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1992,
    stopColor: "#B7EB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    stopColor: "#B6EB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#B5EA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2109,
    stopColor: "#B4E95B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#B2E85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2188,
    stopColor: "#B1E75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#B0E65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2266,
    stopColor: "#AFE55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2305,
    stopColor: "#AEE55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#ADE45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#ACE35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2422,
    stopColor: "#ABE25A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2461,
    stopColor: "#A9E15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A8E05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2539,
    stopColor: "#A7E05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    stopColor: "#A6DF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    stopColor: "#A5DE5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#A4DD5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2695,
    stopColor: "#A3DC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2734,
    stopColor: "#A1DB5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    stopColor: "#A0DA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    stopColor: "#9FDA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2852,
    stopColor: "#9ED95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2891,
    stopColor: "#9DD859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#9CD759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2969,
    stopColor: "#9BD659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3008,
    stopColor: "#9AD559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3047,
    stopColor: "#98D559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#97D459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#96D359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3164,
    stopColor: "#95D259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3203,
    stopColor: "#94D159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    stopColor: "#93D059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3281,
    stopColor: "#92CF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#91CF59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3359,
    stopColor: "#8FCE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3398,
    stopColor: "#8ECD58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3438,
    stopColor: "#8DCC58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3477,
    stopColor: "#8CCB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3516,
    stopColor: "#8BCA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3555,
    stopColor: "#8ACA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3594,
    stopColor: "#89C958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3633,
    stopColor: "#88C858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3672,
    stopColor: "#86C758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    stopColor: "#85C658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#84C558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    stopColor: "#83C458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3828,
    stopColor: "#82C458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3867,
    stopColor: "#81C358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3906,
    stopColor: "#80C257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3945,
    stopColor: "#7FC157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3984,
    stopColor: "#7DC057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4023,
    stopColor: "#7CBF57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4062,
    stopColor: "#7BBF57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4102,
    stopColor: "#7ABE57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4141,
    stopColor: "#79BD57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#78BC57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4219,
    stopColor: "#77BB57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4258,
    stopColor: "#75BA57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4297,
    stopColor: "#74B957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4336,
    stopColor: "#73B957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#72B857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4414,
    stopColor: "#71B756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4453,
    stopColor: "#70B656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#6FB556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4531,
    stopColor: "#6EB456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#6CB456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#6BB356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#6AB256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4688,
    stopColor: "#69B156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4727,
    stopColor: "#68B056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    stopColor: "#67AF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#66AE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#65AE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4883,
    stopColor: "#63AD56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4922,
    stopColor: "#62AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4961,
    stopColor: "#61AB55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#60AA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5039,
    stopColor: "#5FA955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5078,
    stopColor: "#5EA955"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5117,
    stopColor: "#5DA855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5156,
    stopColor: "#5CA755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "#5AA655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#59A555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5273,
    stopColor: "#58A455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5312,
    stopColor: "#57A355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5352,
    stopColor: "#56A355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    stopColor: "#55A255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#54A154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5469,
    stopColor: "#53A054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5508,
    stopColor: "#519F54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5547,
    stopColor: "#509E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#4F9E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#4E9D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5664,
    stopColor: "#4D9C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    stopColor: "#4C9B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5742,
    stopColor: "#4B9A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5781,
    stopColor: "#499954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#489854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#479854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#469754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    stopColor: "#459653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    stopColor: "#449553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6016,
    stopColor: "#439453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6055,
    stopColor: "#429353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6094,
    stopColor: "#409353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6133,
    stopColor: "#3F9253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6172,
    stopColor: "#3E9153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6211,
    stopColor: "#3D9053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3C8F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6289,
    stopColor: "#3B8E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6328,
    stopColor: "#3A8D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6367,
    stopColor: "#398D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    stopColor: "#378C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6445,
    stopColor: "#368B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6484,
    stopColor: "#358A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6523,
    stopColor: "#348952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6562,
    stopColor: "#338852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6602,
    stopColor: "#328852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6641,
    stopColor: "#318752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#308652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    stopColor: "#2E8552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6758,
    stopColor: "#2D8452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6797,
    stopColor: "#2C8352"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6836,
    stopColor: "#2B8252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#2A8252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6914,
    stopColor: "#298152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6953,
    stopColor: "#288051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6992,
    stopColor: "#277F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7031,
    stopColor: "#257E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#247D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7109,
    stopColor: "#237D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7148,
    stopColor: "#227C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#217B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7227,
    stopColor: "#207A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#1F7951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#1D7851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#1C7751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7383,
    stopColor: "#1B7751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7422,
    stopColor: "#1A7650"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    stopColor: "#197550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#187450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7539,
    stopColor: "#177350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7578,
    stopColor: "#167250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7617,
    stopColor: "#147250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7656,
    stopColor: "#137150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7695,
    stopColor: "#127050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7734,
    stopColor: "#116F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7773,
    stopColor: "#106E50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7812,
    stopColor: "#0F6D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7852,
    stopColor: "#0E6C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7891,
    stopColor: "#0D6C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#0B6B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7969,
    stopColor: "#0A6A4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8008,
    stopColor: "#09694F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8047,
    stopColor: "#08684F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8086,
    stopColor: "#07674F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#06674F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#05664F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05664F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88d31352bdedbb10ed70fc4c481d385d.svg";
export { ForwardRef as ReactComponent };